{
  "capital": 7175,
  "initialCapital": 7000,
  "newAccount": false,
  "overall": {
    "total": 24,
    "proportions": [
      {
        "side": "long",
        "total": 13
      },
      {
        "side": "short",
        "total": 11
      }
    ]
  },
  "streaks": {
    "wins": {
      "trades": [
        {
          "id": 1618787408975,
          "ticker": "AMC",
          "date": "17/2/21",
          "returnCash": 91.2
        },
        {
          "id": 1618787468705,
          "ticker": "RIOT",
          "date": "19/2/21",
          "returnCash": 106.8
        }
      ]
    },
    "losses": {
      "trades": [
        {
          "id": 1618787639837,
          "ticker": "VZ",
          "date": "2/3/21",
          "returnCash": -98.4
        },
        {
          "id": 1618787689046,
          "ticker": "TWTR",
          "date": "6/3/21",
          "returnCash": -28.7
        }
      ]
    },
    "current": {
      "trades": [
        {
          "id": 1618788949757,
          "ticker": "WFC",
          "date": "10/4/21",
          "returnCash": 112.8
        },
        {
          "id": 1618790095230,
          "ticker": "RIOT",
          "date": "14/4/21",
          "returnCash": 19.6
        },
        {
          "id": 1618790222518,
          "ticker": "RIOT",
          "date": "14/4/21",
          "returnCash": 42.7
        }
      ]
    }
  },
  "worstTrades": [
    {
      "id": 1618788220763,
      "dateLong": "Sun Mar 28 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "28/3/21",
      "ticker": "TWTR",
      "returnCash": -223.6
    },
    {
      "id": 1618788301421,
      "dateLong": "Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "4/4/21",
      "ticker": "OCGN",
      "returnCash": -158.4
    },
    {
      "id": 1618788047207,
      "dateLong": "Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "21/3/21",
      "ticker": "SNAP",
      "returnCash": -119
    },
    {
      "id": 1618788815800,
      "dateLong": "Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "8/4/21",
      "ticker": "AAL",
      "returnCash": -105
    },
    {
      "id": 1618787639837,
      "dateLong": "Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "2/3/21",
      "ticker": "VZ",
      "returnCash": -98.4
    },
    {
      "id": 1618787878176,
      "dateLong": "Sun Mar 14 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "14/3/21",
      "ticker": "AAL",
      "returnCash": -79
    },
    {
      "id": 1618787516761,
      "dateLong": "Sun Feb 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "21/2/21",
      "ticker": "SNAP",
      "returnCash": -30
    },
    {
      "id": 1618787689046,
      "dateLong": "Sat Mar 06 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "6/3/21",
      "ticker": "TWTR",
      "returnCash": -28.7
    },
    {
      "id": 1618788389926,
      "dateLong": "Tue Apr 06 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "6/4/21",
      "ticker": "WFC",
      "returnCash": -21.5
    }
  ],
  "bestTrades": [
    {
      "id": 1618788552011,
      "dateLong": "Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "8/4/21",
      "ticker": "BMBL",
      "returnCash": 123.6
    },
    {
      "id": 1618788154757,
      "dateLong": "Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "21/3/21",
      "ticker": "NIO",
      "returnCash": 116
    },
    {
      "id": 1618788949757,
      "dateLong": "Sat Apr 10 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "10/4/21",
      "ticker": "WFC",
      "returnCash": 112.8
    },
    {
      "id": 1618787468705,
      "dateLong": "Fri Feb 19 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "19/2/21",
      "ticker": "RIOT",
      "returnCash": 106.8
    },
    {
      "id": 1618787566463,
      "dateLong": "Thu Feb 25 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "25/2/21",
      "ticker": "NIO",
      "returnCash": 101
    },
    {
      "id": 1618787408975,
      "dateLong": "Wed Feb 17 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "17/2/21",
      "ticker": "AMC",
      "returnCash": 91.2
    },
    {
      "id": 1618788260204,
      "dateLong": "Sat Apr 03 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "3/4/21",
      "ticker": "AMC",
      "returnCash": 91
    },
    {
      "id": 1618788358393,
      "dateLong": "Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "4/4/21",
      "ticker": "BMBL",
      "returnCash": 66.5
    },
    {
      "id": 1618787603816,
      "dateLong": "Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "2/3/21",
      "ticker": "BMBL",
      "returnCash": 63.7
    },
    {
      "id": 1618790222518,
      "dateLong": "Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "14/4/21",
      "ticker": "RIOT",
      "returnCash": 42.7
    },
    {
      "id": 1618787828559,
      "dateLong": "Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "11/3/21",
      "ticker": "NIO",
      "returnCash": 41
    },
    {
      "id": 1618787983228,
      "dateLong": "Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "18/3/21",
      "ticker": "AMC",
      "returnCash": 31.2
    },
    {
      "id": 1618790095230,
      "dateLong": "Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "14/4/21",
      "ticker": "RIOT",
      "returnCash": 19.6
    },
    {
      "id": 1618787937979,
      "dateLong": "Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "18/3/21",
      "ticker": "WFC",
      "returnCash": 16
    },
    {
      "id": 1618787722775,
      "dateLong": "Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "11/3/21",
      "ticker": "OCGN",
      "returnCash": 15
    }
  ],
  "tickers": {
    "AMC": {
      "ticker": "AMC",
      "avgReturn": 71.13,
      "trades": [
        {
          "id": 1618787408975,
          "shares": 80,
          "returnCash": 91.2,
          "returnPercent": 1.3
        },
        {
          "id": 1618787983228,
          "shares": 60,
          "returnCash": 31.2,
          "returnPercent": 0.43
        },
        {
          "id": 1618788260204,
          "shares": 100,
          "returnCash": 91,
          "returnPercent": 1.3
        }
      ]
    },
    "RIOT": {
      "ticker": "RIOT",
      "avgReturn": 56.37,
      "trades": [
        {
          "id": 1618787468705,
          "shares": 60,
          "returnCash": 106.8,
          "returnPercent": 1.51
        },
        {
          "id": 1618790095230,
          "shares": 70,
          "returnCash": 19.6,
          "returnPercent": 0.28
        },
        {
          "id": 1618790222518,
          "shares": 70,
          "returnCash": 42.7,
          "returnPercent": 0.6
        }
      ]
    },
    "SNAP": {
      "ticker": "SNAP",
      "avgReturn": -74.5,
      "trades": [
        {
          "id": 1618787516761,
          "shares": 60,
          "returnCash": -30,
          "returnPercent": -0.42
        },
        {
          "id": 1618788047207,
          "shares": 70,
          "returnCash": -119,
          "returnPercent": -1.65
        }
      ]
    },
    "NIO": {
      "ticker": "NIO",
      "avgReturn": 86,
      "trades": [
        {
          "id": 1618787566463,
          "shares": 100,
          "returnCash": 101,
          "returnPercent": 1.41
        },
        {
          "id": 1618787828559,
          "shares": 100,
          "returnCash": 41,
          "returnPercent": 0.57
        },
        {
          "id": 1618788154757,
          "shares": 80,
          "returnCash": 116,
          "returnPercent": 1.63
        }
      ]
    },
    "BMBL": {
      "ticker": "BMBL",
      "avgReturn": 84.6,
      "trades": [
        {
          "id": 1618787603816,
          "shares": 70,
          "returnCash": 63.7,
          "returnPercent": 0.88
        },
        {
          "id": 1618788358393,
          "shares": 70,
          "returnCash": 66.5,
          "returnPercent": 0.96
        },
        {
          "id": 1618788552011,
          "shares": 120,
          "returnCash": 123.6,
          "returnPercent": 1.77
        }
      ]
    },
    "VZ": {
      "ticker": "VZ",
      "avgReturn": -98.4,
      "trades": [
        {
          "id": 1618787639837,
          "shares": 80,
          "returnCash": -98.4,
          "returnPercent": -1.34
        }
      ]
    },
    "TWTR": {
      "ticker": "TWTR",
      "avgReturn": -126.15,
      "trades": [
        {
          "id": 1618787689046,
          "shares": 70,
          "returnCash": -28.7,
          "returnPercent": -0.4
        },
        {
          "id": 1618788220763,
          "shares": 130,
          "returnCash": -223.6,
          "returnPercent": -3.09
        }
      ]
    },
    "OCGN": {
      "ticker": "OCGN",
      "avgReturn": -71.7,
      "trades": [
        {
          "id": 1618787722775,
          "shares": 50,
          "returnCash": 15,
          "returnPercent": 0.21
        },
        {
          "id": 1618788301421,
          "shares": 90,
          "returnCash": -158.4,
          "returnPercent": -2.23
        }
      ]
    },
    "AAL": {
      "ticker": "AAL",
      "avgReturn": -92,
      "trades": [
        {
          "id": 1618787878176,
          "shares": 100,
          "returnCash": -79,
          "returnPercent": -1.09
        },
        {
          "id": 1618788815800,
          "shares": 100,
          "returnCash": -105,
          "returnPercent": -1.48
        }
      ]
    },
    "WFC": {
      "ticker": "WFC",
      "avgReturn": 35.77,
      "trades": [
        {
          "id": 1618787937979,
          "shares": 100,
          "returnCash": 16,
          "returnPercent": 0.22
        },
        {
          "id": 1618788389926,
          "shares": 50,
          "returnCash": -21.5,
          "returnPercent": -0.31
        },
        {
          "id": 1618788949757,
          "shares": 120,
          "returnCash": 112.8,
          "returnPercent": 1.61
        }
      ]
    }
  },
  "calendarData": {
    "feb21": [
      {
        "dateLong": "Wed Feb 17 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
        "dateShort": "17/2/21",
        "trades": [
          {
            "id": 1618787408975,
            "side": "long",
            "returnCash": 91.2,
            "returnPercent": 1.3,
            "total": 7091.2
          }
        ]
      },
      {
        "dateLong": "Fri Feb 19 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
        "dateShort": "19/2/21",
        "trades": [
          {
            "id": 1618787468705,
            "side": "short",
            "returnCash": 106.8,
            "returnPercent": 1.51,
            "total": 7198
          }
        ]
      },
      {
        "dateLong": "Sun Feb 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
        "dateShort": "21/2/21",
        "trades": [
          {
            "id": 1618787516761,
            "side": "short",
            "returnCash": -30,
            "returnPercent": -0.42,
            "total": 7168
          }
        ]
      },
      {
        "dateLong": "Thu Feb 25 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
        "dateShort": "25/2/21",
        "trades": [
          {
            "id": 1618787566463,
            "side": "long",
            "returnCash": 101,
            "returnPercent": 1.41,
            "total": 7269
          }
        ]
      }
    ],
    "mar21": [
      {
        "dateLong": "Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
        "dateShort": "2/3/21",
        "trades": [
          {
            "id": 1618787603816,
            "side": "long",
            "returnCash": 63.7,
            "returnPercent": 0.88,
            "total": 7332.7
          },
          {
            "id": 1618787639837,
            "side": "long",
            "returnCash": -98.4,
            "returnPercent": -1.34,
            "total": 7234.3
          }
        ]
      },
      {
        "dateLong": "Sat Mar 06 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
        "dateShort": "6/3/21",
        "trades": [
          {
            "id": 1618787689046,
            "side": "short",
            "returnCash": -28.7,
            "returnPercent": -0.4,
            "total": 7205.6
          }
        ]
      },
      {
        "dateLong": "Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
        "dateShort": "11/3/21",
        "trades": [
          {
            "id": 1618787722775,
            "side": "long",
            "returnCash": 15,
            "returnPercent": 0.21,
            "total": 7220.6
          },
          {
            "id": 1618787828559,
            "side": "short",
            "returnCash": 41,
            "returnPercent": 0.57,
            "total": 7261.6
          }
        ]
      },
      {
        "dateLong": "Sun Mar 14 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
        "dateShort": "14/3/21",
        "trades": [
          {
            "id": 1618787878176,
            "side": "long",
            "returnCash": -79,
            "returnPercent": -1.09,
            "total": 7182.6
          }
        ]
      },
      {
        "dateLong": "Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
        "dateShort": "18/3/21",
        "trades": [
          {
            "id": 1618787937979,
            "side": "long",
            "returnCash": 16,
            "returnPercent": 0.22,
            "total": 7198.6
          },
          {
            "id": 1618787983228,
            "side": "short",
            "returnCash": 31.2,
            "returnPercent": 0.43,
            "total": 7229.8
          }
        ]
      },
      {
        "dateLong": "Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
        "dateShort": "21/3/21",
        "trades": [
          {
            "id": 1618788047207,
            "side": "long",
            "returnCash": -119,
            "returnPercent": -1.65,
            "total": 7110.8
          },
          {
            "id": 1618788154757,
            "side": "long",
            "returnCash": 116,
            "returnPercent": 1.63,
            "total": 7226.8
          }
        ]
      },
      {
        "dateLong": "Sun Mar 28 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
        "dateShort": "28/3/21",
        "trades": [
          {
            "id": 1618788220763,
            "side": "short",
            "returnCash": -223.6,
            "returnPercent": -3.09,
            "total": 7003.2
          }
        ]
      }
    ],
    "apr21": [
      {
        "dateLong": "Sat Apr 03 2021 00:00:00 GMT+0100 (British Summer Time)",
        "dateShort": "3/4/21",
        "trades": [
          {
            "id": 1618788260204,
            "side": "long",
            "returnCash": 91,
            "returnPercent": 1.3,
            "total": 7094.2
          }
        ]
      },
      {
        "dateLong": "Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)",
        "dateShort": "4/4/21",
        "trades": [
          {
            "id": 1618788301421,
            "side": "short",
            "returnCash": -158.4,
            "returnPercent": -2.23,
            "total": 6935.8
          },
          {
            "id": 1618788358393,
            "side": "short",
            "returnCash": 66.5,
            "returnPercent": 0.96,
            "total": 7002.3
          }
        ]
      },
      {
        "dateLong": "Tue Apr 06 2021 00:00:00 GMT+0100 (British Summer Time)",
        "dateShort": "6/4/21",
        "trades": [
          {
            "id": 1618788389926,
            "side": "long",
            "returnCash": -21.5,
            "returnPercent": -0.31,
            "total": 6980.8
          }
        ]
      },
      {
        "dateLong": "Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)",
        "dateShort": "8/4/21",
        "trades": [
          {
            "id": 1618788552011,
            "side": "short",
            "returnCash": 123.6,
            "returnPercent": 1.77,
            "total": 7104.400000000001
          },
          {
            "id": 1618788815800,
            "side": "long",
            "returnCash": -105,
            "returnPercent": -1.48,
            "total": 6999.400000000001
          }
        ]
      },
      {
        "dateLong": "Sat Apr 10 2021 00:00:00 GMT+0100 (British Summer Time)",
        "dateShort": "10/4/21",
        "trades": [
          {
            "id": 1618788949757,
            "side": "short",
            "returnCash": 112.8,
            "returnPercent": 1.61,
            "total": 7112.200000000001
          }
        ]
      },
      {
        "dateLong": "Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)",
        "dateShort": "14/4/21",
        "trades": [
          {
            "id": 1618790095230,
            "side": "long",
            "returnCash": 19.6,
            "returnPercent": 0.28,
            "total": 7131.800000000001
          },
          {
            "id": 1618790222518,
            "side": "short",
            "returnCash": 42.7,
            "returnPercent": 0.6,
            "total": 7174.500000000001
          }
        ]
      }
    ]
  },
  "journal": [
    {
      "id": 1618787408975,
      "dateLong": "Wed Feb 17 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "17/2/21",
      "ticker": "AMC",
      "side": "long",
      "tradeEntries": [
        [9.45, 40],
        [9.62, 40]
      ],
      "tradeExits": [[10.68, 80]],
      "sharesAmount": 80,
      "avgEntry": 9.54,
      "avgExit": 10.68,
      "returnCash": 91.2,
      "returnPercent": 1.3,
      "body": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae sapien pellentesque habitant morbi. Aliquam id diam maecenas ultricies mi eget. Montes nascetur ridiculus mus mauris vitae ultricies. Eget felis eget nunc lobortis. Sed lectus vestibulum mattis ullamcorper velit sed ullamcorper morbi. Interdum velit laoreet id donec. Ac feugiat sed lectus vestibulum mattis ullamcorper velit sed ullamcorper. Lacus sed turpis tincidunt id aliquet risus feugiat. Egestas integer eget aliquet nibh praesent tristique magna sit amet.",
      "previousTicker": "AMC",
      "previousDateShort": "17/2/21",
      "previousDateLong": "Wed Feb 17 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7091.2
    },
    {
      "id": 1618787468705,
      "dateLong": "Fri Feb 19 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "19/2/21",
      "ticker": "RIOT",
      "side": "short",
      "tradeEntries": [[49.94, 60]],
      "tradeExits": [[48.16, 60]],
      "sharesAmount": 60,
      "avgEntry": 49.94,
      "avgExit": 48.16,
      "returnCash": 106.8,
      "returnPercent": 1.51,
      "body": "Sed libero enim sed faucibus. Amet consectetur adipiscing elit pellentesque habitant morbi tristique senectus. Vel fringilla est ullamcorper eget nulla facilisi. Quam lacus suspendisse faucibus interdum posuere lorem ipsum. Porttitor leo a diam sollicitudin. Morbi non arcu risus quis varius. Nibh tellus molestie nunc non blandit massa. Vel turpis nunc eget lorem dolor sed viverra ipsum nunc. Tellus id interdum velit laoreet id donec. Ipsum consequat nisl vel pretium lectus quam. Ut tristique et egestas quis ipsum. ",
      "previousTicker": "RIOT",
      "previousDateShort": "19/2/21",
      "previousDateLong": "Fri Feb 19 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7198
    },
    {
      "id": 1618787516761,
      "dateLong": "Sun Feb 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "21/2/21",
      "ticker": "SNAP",
      "side": "short",
      "tradeEntries": [
        [63.17, 40],
        [63.33, 20]
      ],
      "tradeExits": [[63.72, 60]],
      "sharesAmount": 60,
      "avgEntry": 63.22,
      "avgExit": 63.72,
      "returnCash": -30,
      "returnPercent": -0.42,
      "body": "",
      "previousTicker": "SNAP",
      "previousDateShort": "21/2/21",
      "previousDateLong": "Sun Feb 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7168
    },
    {
      "id": 1618787566463,
      "dateLong": "Thu Feb 25 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "25/2/21",
      "ticker": "NIO",
      "side": "long",
      "tradeEntries": [
        [38.11, 50],
        [38.22, 50]
      ],
      "tradeExits": [[39.17, 100]],
      "sharesAmount": 100,
      "avgEntry": 38.16,
      "avgExit": 39.17,
      "returnCash": 101,
      "returnPercent": 1.41,
      "body": "At auctor urna nunc id cursus. Maecenas pharetra convallis posuere morbi leo urna molestie at elementum. Lacinia at quis risus sed vulputate odio ut. Posuere lorem ipsum dolor sit amet consectetur adipiscing. Sed elementum tempus egestas sed sed risus pretium quam. Sit amet massa vitae tortor condimentum lacinia quis vel. Eget felis eget nunc lobortis. Netus et malesuada fames ac turpis egestas sed tempus urna. Diam quam nulla porttitor massa id neque. Convallis posuere morbi leo urna. Mauris cursus mattis molestie a iaculis. Ultricies lacus sed turpis tincidunt id aliquet risus feugiat in. Scelerisque mauris pellentesque pulvinar pellentesque. ",
      "previousTicker": "NIO",
      "previousDateShort": "25/2/21",
      "previousDateLong": "Thu Feb 25 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7269
    },
    {
      "id": 1618787603816,
      "dateLong": "Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "2/3/21",
      "ticker": "BMBL",
      "side": "long",
      "tradeEntries": [[60.16, 70]],
      "tradeExits": [[61.07, 70]],
      "sharesAmount": 70,
      "avgEntry": 60.16,
      "avgExit": 61.07,
      "returnCash": 63.7,
      "returnPercent": 0.88,
      "body": "",
      "previousTicker": "BMBL",
      "previousDateShort": "2/3/21",
      "previousDateLong": "Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7332.7
    },
    {
      "id": 1618787639837,
      "dateLong": "Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "2/3/21",
      "ticker": "VZ",
      "side": "long",
      "tradeEntries": [[57.47, 80]],
      "tradeExits": [[56.24, 80]],
      "sharesAmount": 80,
      "avgEntry": 57.47,
      "avgExit": 56.24,
      "returnCash": -98.4,
      "returnPercent": -1.34,
      "body": "Morbi blandit cursus risus at ultrices mi tempus. Amet cursus sit amet dictum sit amet. Viverra accumsan in nisl nisi. Mauris pellentesque pulvinar pellentesque habitant morbi. Eleifend quam adipiscing vitae proin sagittis nisl. Risus commodo viverra maecenas accumsan lacus vel facilisis. Porta lorem mollis aliquam ut porttitor leo. Odio morbi quis commodo odio aenean. ",
      "previousTicker": "VZ",
      "previousDateShort": "2/3/21",
      "previousDateLong": "Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7234.3
    },
    {
      "id": 1618787689046,
      "dateLong": "Sat Mar 06 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "6/3/21",
      "ticker": "TWTR",
      "side": "short",
      "tradeEntries": [[71.96, 70]],
      "tradeExits": [[72.37, 70]],
      "sharesAmount": 70,
      "avgEntry": 71.96,
      "avgExit": 72.37,
      "returnCash": -28.7,
      "returnPercent": -0.4,
      "body": "Volutpat odio facilisis mauris sit amet massa. Dui sapien eget mi proin sed libero enim sed. Morbi tempus iaculis urna id volutpat lacus laoreet. Tempus urna et pharetra pharetra. Et tortor at risus viverra. Quam viverra orci sagittis eu volutpat odio. Enim diam vulputate ut pharetra sit. Nibh sit amet commodo nulla facilisi nullam vehicula. Vivamus at augue eget arcu dictum varius. Faucibus a pellentesque sit amet porttitor. Justo nec ultrices dui sapien eget mi proin sed libero. Eleifend donec pretium vulputate sapien nec. Cursus mattis molestie a iaculis at erat pellentesque adipiscing. ",
      "previousTicker": "TWTR",
      "previousDateShort": "6/3/21",
      "previousDateLong": "Sat Mar 06 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7205.6
    },
    {
      "id": 1618787722775,
      "dateLong": "Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "11/3/21",
      "ticker": "OCGN",
      "side": "long",
      "tradeEntries": [[6.68, 50]],
      "tradeExits": [[6.98, 50]],
      "sharesAmount": 50,
      "avgEntry": 6.68,
      "avgExit": 6.98,
      "returnCash": 15,
      "returnPercent": 0.21,
      "body": "",
      "previousTicker": "OCGN",
      "previousDateShort": "11/3/21",
      "previousDateLong": "Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7220.6
    },
    {
      "id": 1618787828559,
      "dateLong": "Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "11/3/21",
      "ticker": "NIO",
      "side": "short",
      "tradeEntries": [[34.43, 100]],
      "tradeExits": [[34.02, 100]],
      "sharesAmount": 100,
      "avgEntry": 34.43,
      "avgExit": 34.02,
      "returnCash": 41,
      "returnPercent": 0.57,
      "body": "Sed blandit libero volutpat sed. Nunc congue nisi vitae suscipit tellus. Lectus sit amet est placerat in. Commodo sed egestas egestas fringilla phasellus faucibus scelerisque eleifend. Purus gravida quis blandit turpis cursus in hac. Facilisis magna etiam tempor orci eu. Dignissim suspendisse in est ante in nibh mauris cursus. Aliquet nibh praesent tristique magna sit amet purus gravida. Non quam lacus suspendisse faucibus interdum posuere lorem ipsum dolor. Urna cursus eget nunc scelerisque viverra mauris. Accumsan lacus vel facilisis volutpat est velit egestas dui. Lobortis scelerisque fermentum dui faucibus. Et netus et malesuada fames. Dui id ornare arcu odio ut sem.",
      "previousTicker": "NIO",
      "previousDateShort": "11/3/21",
      "previousDateLong": "Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7261.6
    },
    {
      "id": 1618787878176,
      "dateLong": "Sun Mar 14 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "14/3/21",
      "ticker": "AAL",
      "side": "long",
      "tradeEntries": [
        [22.03, 60],
        [21.98, 40]
      ],
      "tradeExits": [[21.22, 100]],
      "sharesAmount": 100,
      "avgEntry": 22.01,
      "avgExit": 21.22,
      "returnCash": -79,
      "returnPercent": -1.09,
      "body": "Quisque egestas diam in arcu cursus euismod quis viverra nibh. Vestibulum morbi blandit cursus risus at ultrices mi tempus imperdiet. Urna et pharetra pharetra massa. Commodo odio aenean sed adipiscing diam donec adipiscing tristique risus. Vulputate sapien nec sagittis aliquam malesuada bibendum arcu vitae. Auctor eu augue ut lectus arcu bibendum. Morbi tempus iaculis urna id. Metus aliquam eleifend mi in nulla posuere sollicitudin aliquam. ",
      "previousTicker": "AAL",
      "previousDateShort": "14/3/21",
      "previousDateLong": "Sun Mar 14 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7182.6
    },
    {
      "id": 1618787937979,
      "dateLong": "Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "18/3/21",
      "ticker": "WFC",
      "side": "long",
      "tradeEntries": [
        [42.24, 50],
        [42.42, 50]
      ],
      "tradeExits": [[42.49, 100]],
      "sharesAmount": 100,
      "avgEntry": 42.33,
      "avgExit": 42.49,
      "returnCash": 16,
      "returnPercent": 0.22,
      "body": "Vitae proin sagittis nisl rhoncus mattis rhoncus urna neque. Amet dictum sit amet justo donec. Sit amet volutpat consequat mauris. Integer malesuada nunc vel risus commodo viverra maecenas accumsan lacus. Mauris commodo quis imperdiet massa. Euismod elementum nisi quis eleifend quam adipiscing vitae proin. Orci nulla pellentesque dignissim enim sit amet venenatis.",
      "previousTicker": "WFC",
      "previousDateShort": "18/3/21",
      "previousDateLong": "Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7198.6
    },
    {
      "id": 1618787983228,
      "dateLong": "Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "18/3/21",
      "ticker": "AMC",
      "side": "short",
      "tradeEntries": [[10.76, 60]],
      "tradeExits": [[10.24, 60]],
      "sharesAmount": 60,
      "avgEntry": 10.76,
      "avgExit": 10.24,
      "returnCash": 31.2,
      "returnPercent": 0.43,
      "body": "Dui id ornare arcu odio ut sem nulla. Nec ultrices dui sapien eget mi proin sed. Etiam sit amet nisl purus in. Nec tincidunt praesent semper feugiat nibh sed pulvinar. Cursus in hac habitasse platea dictumst quisque sagittis purus. Id venenatis a condimentum vitae sapien pellentesque habitant morbi. Facilisi etiam dignissim diam quis enim lobortis. Orci phasellus egestas tellus rutrum. Malesuada pellentesque elit eget gravida cum. Velit sed ullamcorper morbi tincidunt.",
      "previousTicker": "AMC",
      "previousDateShort": "18/3/21",
      "previousDateLong": "Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7229.8
    },
    {
      "id": 1618788047207,
      "dateLong": "Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "21/3/21",
      "ticker": "SNAP",
      "side": "long",
      "tradeEntries": [
        [64.66, 40],
        [64.56, 30]
      ],
      "tradeExits": [[62.92, 70]],
      "sharesAmount": 70,
      "avgEntry": 64.62,
      "avgExit": 62.92,
      "returnCash": -119,
      "returnPercent": -1.65,
      "body": "Egestas quis ipsum suspendisse ultrices gravida dictum. Lorem sed risus ultricies tristique nulla aliquet enim. Montes nascetur ridiculus mus mauris vitae ultricies leo. Nisl condimentum id venenatis a condimentum vitae. Eu lobortis elementum nibh tellus molestie nunc non blandit. Praesent semper feugiat nibh sed pulvinar. Eget nulla facilisi etiam dignissim diam quis enim. Purus ut faucibus pulvinar elementum integer enim. Leo urna molestie at elementum eu facilisis sed. Sit amet est placerat in egestas erat imperdiet sed euismod. Varius vel pharetra vel turpis nunc eget lorem. Laoreet suspendisse interdum consectetur libero id faucibus nisl tincidunt.",
      "previousTicker": "SNAP",
      "previousDateShort": "21/3/21",
      "previousDateLong": "Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7110.8
    },
    {
      "id": 1618788154757,
      "dateLong": "Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "21/3/21",
      "ticker": "NIO",
      "side": "long",
      "tradeEntries": [
        [44.43, 50],
        [44.67, 30]
      ],
      "tradeExits": [[45.97, 80]],
      "sharesAmount": 80,
      "avgEntry": 44.52,
      "avgExit": 45.97,
      "returnCash": 116,
      "returnPercent": 1.63,
      "body": "Nibh praesent tristique magna sit amet purus gravida quis blandit. Mattis pellentesque id nibh tortor id aliquet lectus proin. Proin nibh nisl condimentum id venenatis a condimentum. Hac habitasse platea dictumst vestibulum. Arcu non odio euismod lacinia at quis risus sed vulputate. Sed arcu non odio euismod lacinia at. Non pulvinar neque laoreet suspendisse interdum consectetur libero id. Cursus euismod quis viverra nibh cras pulvinar. Vulputate sapien nec sagittis aliquam malesuada bibendum arcu vitae elementum. Vivamus arcu felis bibendum ut. Et sollicitudin ac orci phasellus egestas. Sit amet justo donec enim. Sed blandit libero volutpat sed cras ornare. Ipsum suspendisse ultrices gravida dictum. Posuere sollicitudin aliquam ultrices sagittis. ",
      "previousTicker": "NIO",
      "previousDateShort": "21/3/21",
      "previousDateLong": "Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7226.8
    },
    {
      "id": 1618788220763,
      "dateLong": "Sun Mar 28 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "dateShort": "28/3/21",
      "ticker": "TWTR",
      "side": "short",
      "tradeEntries": [
        [78.45, 100],
        [78.32, 30]
      ],
      "tradeExits": [[80.14, 130]],
      "sharesAmount": 130,
      "avgEntry": 78.42,
      "avgExit": 80.14,
      "returnCash": -223.6,
      "returnPercent": -3.09,
      "body": "",
      "previousTicker": "TWTR",
      "previousDateShort": "28/3/21",
      "previousDateLong": "Sun Mar 28 2021 00:00:00 GMT+0000 (Greenwich Mean Time)",
      "total": 7003.2
    },
    {
      "id": 1618788260204,
      "dateLong": "Sat Apr 03 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "3/4/21",
      "ticker": "AMC",
      "side": "long",
      "tradeEntries": [
        [12.47, 50],
        [12.61, 50]
      ],
      "tradeExits": [[13.45, 100]],
      "sharesAmount": 100,
      "avgEntry": 12.54,
      "avgExit": 13.45,
      "returnCash": 91,
      "returnPercent": 1.3,
      "body": "Sed felis eget velit aliquet sagittis. Arcu cursus vitae congue mauris rhoncus aenean vel. Imperdiet proin fermentum leo vel orci porta. Sagittis purus sit amet volutpat consequat mauris nunc congue. Aliquam sem fringilla ut morbi tincidunt. Sagittis vitae et leo duis ut diam quam nulla porttitor. Nunc non blandit massa enim. At consectetur lorem donec massa sapien faucibus. Lorem ipsum dolor sit amet consectetur. Vulputate enim nulla aliquet porttitor lacus luctus accumsan. Nec feugiat in fermentum posuere urna nec tincidunt. Neque vitae tempus quam pellentesque.",
      "previousTicker": "AMC",
      "previousDateShort": "3/4/21",
      "previousDateLong": "Sat Apr 03 2021 00:00:00 GMT+0100 (British Summer Time)",
      "total": 7094.2
    },
    {
      "id": 1618788301421,
      "dateLong": "Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "4/4/21",
      "ticker": "OCGN",
      "side": "short",
      "tradeEntries": [[7.26, 90]],
      "tradeExits": [[9.02, 90]],
      "sharesAmount": 90,
      "avgEntry": 7.26,
      "avgExit": 9.02,
      "returnCash": -158.4,
      "returnPercent": -2.23,
      "body": "Placerat in egestas erat imperdiet sed euismod. Pretium quam vulputate dignissim suspendisse in est ante in. Elementum integer enim neque volutpat ac tincidunt. Mollis aliquam ut porttitor leo a diam. Ultricies mi quis hendrerit dolor magna eget est. Pharetra sit amet aliquam id. Ut etiam sit amet nisl. Facilisis magna etiam tempor orci eu. Lorem dolor sed viverra ipsum nunc aliquet. Aliquet risus feugiat in ante metus dictum at tempor. Tortor consequat id porta nibh venenatis cras sed. At tellus at urna condimentum mattis pellentesque.",
      "previousTicker": "OCGN",
      "previousDateShort": "4/4/21",
      "previousDateLong": "Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)",
      "total": 6935.8
    },
    {
      "id": 1618788358393,
      "dateLong": "Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "4/4/21",
      "ticker": "BMBL",
      "side": "short",
      "tradeEntries": [[59.89, 70]],
      "tradeExits": [
        [59.02, 30],
        [58.88, 40]
      ],
      "sharesAmount": 70,
      "avgEntry": 59.89,
      "avgExit": 58.94,
      "returnCash": 66.5,
      "returnPercent": 0.96,
      "body": "Varius duis at consectetur lorem donec. Consequat ac felis donec et. Gravida quis blandit turpis cursus in hac. Tellus in metus vulputate eu scelerisque felis imperdiet. Accumsan lacus vel facilisis volutpat est velit egestas. Amet nulla facilisi morbi tempus iaculis. Blandit massa enim nec dui nunc mattis enim ut tellus. Vel risus commodo viverra maecenas accumsan lacus. Parturient montes nascetur ridiculus mus mauris vitae ultricies leo integer. Massa enim nec dui nunc.",
      "previousTicker": "BMBL",
      "previousDateShort": "4/4/21",
      "previousDateLong": "Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)",
      "total": 7002.3
    },
    {
      "id": 1618788389926,
      "dateLong": "Tue Apr 06 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "6/4/21",
      "ticker": "WFC",
      "side": "long",
      "tradeEntries": [[49.54, 50]],
      "tradeExits": [[49.11, 50]],
      "sharesAmount": 50,
      "avgEntry": 49.54,
      "avgExit": 49.11,
      "returnCash": -21.5,
      "returnPercent": -0.31,
      "body": "",
      "previousTicker": "WFC",
      "previousDateShort": "6/4/21",
      "previousDateLong": "Tue Apr 06 2021 00:00:00 GMT+0100 (British Summer Time)",
      "total": 6980.8
    },
    {
      "id": 1618788552011,
      "dateLong": "Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "8/4/21",
      "ticker": "BMBL",
      "side": "short",
      "tradeEntries": [
        [63.37, 70],
        [63.25, 50]
      ],
      "tradeExits": [
        [62.44, 60],
        [62.14, 60]
      ],
      "sharesAmount": 120,
      "avgEntry": 63.32,
      "avgExit": 62.29,
      "returnCash": 123.6,
      "returnPercent": 1.77,
      "body": "Sodales ut eu sem integer vitae justo eget. Commodo viverra maecenas accumsan lacus vel facilisis volutpat est. Varius quam quisque id diam vel quam elementum pulvinar. Sed ullamcorper morbi tincidunt ornare massa eget. Tincidunt arcu non sodales neque sodales ut etiam sit amet. Netus et malesuada fames ac turpis. Velit aliquet sagittis id consectetur purus. Vestibulum lectus mauris ultrices eros in cursus. Sem integer vitae justo eget magna. Scelerisque mauris pellentesque pulvinar pellentesque. Id consectetur purus ut faucibus pulvinar elementum integer. Odio euismod lacinia at quis risus sed vulputate. Nulla facilisi nullam vehicula ipsum a arcu cursus vitae congue. Sed egestas egestas fringilla phasellus faucibus scelerisque eleifend donec pretium. In nisl nisi scelerisque eu. Vitae sapien pellentesque habitant morbi tristique senectus. Facilisi etiam dignissim diam quis.",
      "previousTicker": "BMBL",
      "previousDateShort": "8/4/21",
      "previousDateLong": "Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)",
      "total": 7104.400000000001
    },
    {
      "id": 1618788815800,
      "dateLong": "Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "8/4/21",
      "ticker": "AAL",
      "side": "long",
      "tradeEntries": [[23.57, 100]],
      "tradeExits": [[22.52, 100]],
      "sharesAmount": 100,
      "avgEntry": 23.57,
      "avgExit": 22.52,
      "returnCash": -105,
      "returnPercent": -1.48,
      "body": "",
      "previousTicker": "AAL",
      "previousDateShort": "8/4/21",
      "previousDateLong": "Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)",
      "total": 6999.400000000001
    },
    {
      "id": 1618788949757,
      "dateLong": "Sat Apr 10 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "10/4/21",
      "ticker": "WFC",
      "side": "short",
      "tradeEntries": [
        [42.27, 70],
        [42.11, 50]
      ],
      "tradeExits": [
        [41.44, 40],
        [41.31, 40],
        [41.02, 40]
      ],
      "sharesAmount": 120,
      "avgEntry": 42.2,
      "avgExit": 41.26,
      "returnCash": 112.8,
      "returnPercent": 1.61,
      "body": "Enim tortor at auctor urna nunc. Pellentesque pulvinar pellentesque habitant morbi tristique. Leo vel orci porta non pulvinar. Porta nibh venenatis cras sed. Sapien pellentesque habitant morbi tristique senectus. At ultrices mi tempus imperdiet. Pretium vulputate sapien nec sagittis aliquam malesuada bibendum arcu vitae. Integer eget aliquet nibh praesent tristique magna sit amet purus. Ullamcorper sit amet risus nullam eget felis eget nunc lobortis. Enim sit amet venenatis urna cursus eget. Sed nisi lacus sed viverra tellus. Morbi tempus iaculis urna id volutpat. Ipsum dolor sit amet consectetur adipiscing elit ut aliquam purus. Sapien eget mi proin sed libero enim sed faucibus turpis. Neque egestas congue quisque egestas diam in arcu cursus.",
      "previousTicker": "WFC",
      "previousDateShort": "10/4/21",
      "previousDateLong": "Sat Apr 10 2021 00:00:00 GMT+0100 (British Summer Time)",
      "total": 7112.200000000001
    },
    {
      "id": 1618790095230,
      "dateLong": "Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "14/4/21",
      "ticker": "RIOT",
      "side": "long",
      "tradeEntries": [[49.7, 70]],
      "tradeExits": [[49.98, 70]],
      "sharesAmount": 70,
      "avgEntry": 49.7,
      "avgExit": 49.98,
      "returnCash": 19.6,
      "returnPercent": 0.28,
      "body": "",
      "previousTicker": "RIOT",
      "previousDateShort": "14/4/21",
      "previousDateLong": "Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)",
      "total": 7131.800000000001
    },
    {
      "id": 1618790222518,
      "dateLong": "Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)",
      "dateShort": "14/4/21",
      "ticker": "RIOT",
      "side": "short",
      "tradeEntries": [[50.69, 70]],
      "tradeExits": [
        [50.13, 30],
        [50.04, 40]
      ],
      "sharesAmount": 70,
      "avgEntry": 50.69,
      "avgExit": 50.08,
      "returnCash": 42.7,
      "returnPercent": 0.6,
      "body": "",
      "previousTicker": "RIOT",
      "previousDateShort": "14/4/21",
      "previousDateLong": "Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)",
      "total": 7174.500000000001
    }
  ],
  "dummyJournal": [
    {
      "id": "",
      "dateLong": "",
      "dateShort": "",
      "ticker": "",
      "side": "",
      "tradeEntries": [["", ""]],
      "tradeExits": [["", ""]],
      "sharesAmount": "",
      "avgEntry": "",
      "avgExit": "",
      "returnCash": "",
      "returnPercent": "",
      "total": "",
      "previousTicker": "",
      "previousDateShort": "",
      "previousDateLong": "",
      "body": ""
    }
  ]
}
